import React from "react";
import BulasikMakinaDeterjaniPro from "../Components/product/BulasikMakinaDeterjaniPro";
import PageHeader from "../Components/common/PageHeader";
import { t } from "i18next";
import ProductSEO from "../Components/common/ProductSEO";

function BulasikMakinaDeterjaniProPage() {
    return (
        <>
            <ProductSEO
                name="Bulaşık Makina Deterjanı Pro"
                description="Profesyonel formül ile yüksek performanslı temizleme; ağır kirlerde etkili."
                slug="bulasikmakinapro"
                imagePath="assets/images/20-kg/13.webp"
            />
            <PageHeader title={t("BULAŞIK MAKİNA DETERJANı PRO")} />
            <BulasikMakinaDeterjaniPro />
        </>
    );
}

export default BulasikMakinaDeterjaniProPage;